module.exports = __webpack_public_path__ + "img/image7.4bc59078.jpg";